// extracted by mini-css-extract-plugin
export default {"cta":"ProductCardOkoOption-module__cta-e9p0Dz"};